import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { get_decision_history } from "../services/api";
import { rootRoute } from "../../../config";
import { errorMsg } from "../../../helper/helpers";
import { motion } from "framer-motion";
import prevArrow from "../assets/prevArrow.png";
import leftArrow from "../assets/leftArrow.png";
import rightArrow from "../assets/rightArrow.png";
import clock from "../assets/clock.png";
import target from "../assets/target.png";
import task_indicator_achieved from '../assets/task_indicator_achieved.png';
import task_indicator_notachieved from '../assets/task_indicator_notachieved.png';
import profitreport from "../assets/profitreport.png";
import trophy from "../assets/trophy.png";
import PmModuleStyle from "../styles/pm.module.css";

const DecisionHistory = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [listOfUsers, setListOfUsers] = useState([]);
  const [simulationDetailSummary, setSimulationDetailSummary] = useState([]);
  const [decisionhistory, setDecisionhistory] = useState([]);
  const [attempt, setAttempt] = useState(queryParams.get("attempt"));
  const [pagination, setPagination] = useState({ prev: false, next: false });
  const [executioninstanceid, setExecutioninstanceid] = useState("");
  const [decisionPageHeight, setDecisionPageHeight] = useState("");
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError,] = useOutletContext();
  const noOfRatings = [1, 2, 3, 4, 5];
  const starRating = Number(decisionhistory?.summary?.starRating);
  const TargetSR = simObj?.laststate?.TargetSR;

  let session_id = queryParams.get("sid");
  let resource_id = queryParams.get("resid");
  let course_id = queryParams.get("cid");
  let user_id = queryParams.get("userid");
  let attempt_id = queryParams.get("attempt");
  let role = queryParams.get("role");

  const formatNum = (num) => {
    return num?.toLocaleString('en-US', { style: 'decimal' });
  }

  const checkNum = (num, factor) => {
    return num < 0
      ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
        minimumFractionDigits: factor,
        maximumFractionDigits: factor,
      })}`
      : `$${num?.toLocaleString(undefined, {
        minimumFractionDigits: factor,
        maximumFractionDigits: factor,
      })}`;
  };
  const initDecisionHistory = () => {
    (simObj?.status != 'COMPLETED' && (attempt == undefined && user_id == undefined)) && navigate(`${rootRoute}/pm/simulation`);
    window.$("html, body").animate({ scrollTop: 0 }, 100);
    setIsLoader(true);
  };
  const backToSimulationList = () => {
    setIsLoader(true);
    if (role == "student") {
      navigate(rootRoute + `/pm/studentreview?${queryParams}`);
    } else {
      navigate(rootRoute + `/pm/instructorreview?${queryParams}`);
    }
  };
  const getNextAttempt = () => {
    setIsLoader(true);
    let index = simulationDetailSummary?.findIndex(
      (sdObj) => sdObj.attemptno == attempt
    );
    let currSdSObj = simulationDetailSummary[index + 1];
    if (currSdSObj != undefined) {
      setAttempt(currSdSObj.attemptno);
      queryParams.set("attempt", currSdSObj.attemptno);
      setExecutioninstanceid(currSdSObj?.executioninstanceid);
      simulationDetailSummary[index + 2] != undefined
        ? setPagination({ prev: true, next: false })
        : setPagination({ prev: false, next: true });
    } else {
      setPagination({ prev: false, next: true });
      setIsLoader(false);
    }
  };
  const getPrevAttempt = () => {
    setIsLoader(true);
    let index = simulationDetailSummary?.findIndex(
      (sdObj) => sdObj.attemptno == attempt
    );
    let currSdSObj = simulationDetailSummary[index - 1];
    if (currSdSObj != undefined) {
      setAttempt(currSdSObj.attemptno);
      queryParams.set("attempt", currSdSObj.attemptno);
      setExecutioninstanceid(currSdSObj?.executioninstanceid);
      simulationDetailSummary[index - 2] != undefined
        ? setPagination({ prev: false, next: false })
        : setPagination({ prev: true, next: false });
    } else {
      setPagination({ prev: true, next: false });
      setIsLoader(false);
    }
  };
  const OnLoadPagination = () => {
    let lastObjIndex = simulationDetailSummary?.length - 1;
    let firstObjIndex = 0;
    let currentIndex = simulationDetailSummary?.findIndex(
      (sdObj) => sdObj.attemptno == attempt
    );
    currentIndex == lastObjIndex && setPagination({ prev: false, next: true });
    currentIndex == firstObjIndex && setPagination({ prev: true, next: false });
    if (currentIndex != lastObjIndex && currentIndex != firstObjIndex) {
      setPagination({ prev: false, next: false });
    }
  };
  const getSimulationDetailSummary = () => {
    setSimulationDetailSummary(
      attempt != undefined && user_id != undefined
        ? simObj?.simulationdetails
        : []
    );
    setIsLoader(false);
  };
  const updateExcutionInstanceId = () => {
    if (attempt != undefined && user_id != undefined) {
      setExecutioninstanceid(
        simulationDetailSummary?.filter(
          (sdObj) => sdObj.attemptno == attempt
        )[0]?.executioninstanceid
      );
    } else {
      setExecutioninstanceid(simObj?.executioninstanceid);
    }
  };
  const getDecisionHistory = () => {
    (simObj?.sessionid != undefined || session_id != undefined) &&
      executioninstanceid != undefined &&
      executioninstanceid.length > 0 &&
      get_decision_history(simObj?.sessionid || session_id, executioninstanceid)
        .then((response) => {
          if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
            setError(response?.data)
          }
          else{
            setDecisionhistory(response?.data);
            OnLoadPagination();
            setIsLoader(false);
            setIsOverlay(false);
            console.log(response?.data)
          }
        })
        .catch((error) => {
          // setError(errorMsg);
          setError({"id":"00000","msg":errorMsg})
          console.log(error);
        });
  };

  useEffect(() => {
    updateExcutionInstanceId();
  }, [simulationDetailSummary]);
  useEffect(() => {
    getSimulationDetailSummary();
    if (document.querySelector(`.${PmModuleStyle["decision-table"]}`) != null) {
      document.querySelector(
        `.${PmModuleStyle["decision-table"]}`
      ).scrollTop = 0;
    }
  }, [attempt]);
  useEffect(() => {
    getDecisionHistory();
  }, [executioninstanceid]);
  useEffect(() => {
    session_id = queryParams.get("sid");
    resource_id = queryParams.get("resid");
    course_id = queryParams.get("cid");
    user_id = queryParams.get("userid");
    attempt_id = queryParams.get("attempt");
    role = queryParams.get("role");
    if(document.querySelector("header.header") != null){
      document.querySelector("header.header").style.display = "none";
    }
    // document.querySelector(
    //   `.${PmModuleStyle["decisionhistory-container"]} header.header h1`
    // ).tabIndex = -1;
    const decisionHistoryPageHeight =
      window.innerHeight -
      document.getElementsByClassName(`${PmModuleStyle.header}`)[0]
        .clientHeight -
      document.getElementsByClassName(`${PmModuleStyle.header2}`)[0]
        .clientHeight -
      document.getElementsByClassName(
        `ui grid ${PmModuleStyle.ui} ${PmModuleStyle.grid}`
      )[0].clientHeight -
      document.querySelector(`.footer`).clientHeight -
      20;
    setDecisionPageHeight(decisionHistoryPageHeight);
    document.querySelector(".App .row").style.minHeight = "auto";
    document.querySelector(".App").style.overflow = "hidden";
    initDecisionHistory();
    setAttempt(queryParams.get("attempt"));
    // if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
    //   document.querySelector(
    //     "footer.footer .footer-nav .footer-links"
    //   ).style.display = "none";
    // }
    // if (document.querySelector("footer.footer .container") != null) {
    //   document.querySelector("footer.footer .container").style.justifyContent =
    //     "center";
    // }
    if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
      document.querySelector("footer.footer .footer-nav .footer-links").firstChild.style.display = "none";
    }
    document.title = "Project Management | Decision History";
    setIsOverlay(false);
    return () => {
      document.querySelector(".App .row").style.minHeight = "100vh";
      document.body.style.overflow = "auto";
      if (
        document.querySelector(
          `.${PmModuleStyle["decisionhistory-container"]} header.header`
        ) != undefined
      ) {
        document.querySelector(
          `.${PmModuleStyle["decisionhistory-container"]} header.header`
        ).style.display = "block";
      }
      if (
        document.querySelector("footer.footer .footer-nav .footer-links") !=
        null
      ) {
        document.querySelector(
          "footer.footer .footer-nav .footer-links"
        ).style.display = "block";
      }
      if (document.querySelector("footer.footer .container") != null) {
        document.querySelector(
          "footer.footer .container"
        ).style.justifyContent = "space-between";
      }
    };
  }, []);

  return (
    <motion.div
      className={`${PmModuleStyle["decisionhistory-container"]}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <header className={`header ${PmModuleStyle.header}`}>
        <div className={`container ${PmModuleStyle.container}`}>
          <div className={`${PmModuleStyle["icon-header-box"]}`}>
            {attempt != undefined && user_id != undefined && (
              <button onClick={backToSimulationList}>
                <img src={prevArrow} />
              </button>
            )}
          </div>
          <h1>Decision History</h1>
        </div>
      </header>
      <div className={`${PmModuleStyle["decisionhistory-wrapper"]}`}>
        <div className={`${PmModuleStyle.header2}`}>
          <h3>
            {attempt != undefined &&
              `Project Management Simulation (Attempt ${attempt})`}
          </h3>

          <div>
            {attempt != undefined &&
              user_id != undefined &&
              simulationDetailSummary?.length != 1 && (
                <div className={`${PmModuleStyle["pagination-icons"]}`}>
                  <button disabled={pagination.prev} onClick={getPrevAttempt}>
                    <img src={leftArrow} />
                  </button>
                  <button disabled={pagination.next} onClick={getNextAttempt}>
                    <img src={rightArrow} />
                  </button>
                </div>
              )}
          </div>
        </div>
        <div className={`ui grid ${PmModuleStyle.ui} ${PmModuleStyle.grid}`}>
          <div className={`column ${PmModuleStyle.column}`}>
            <img src={clock} />
            <span>
              {decisionhistory?.summary?.startday}-
              {decisionhistory?.summary?.endday}
              {/* 6/14/22-6/29/22 */}
            </span>
            <p>Simulation Started - Ended</p>
          </div>
          <div className={`column ${PmModuleStyle.column}`}>
            <img src={target} />
            <span>
              {decisionhistory?.summary?.projectedProjectCost ? checkNum(Number(decisionhistory?.summary?.projectedProjectCost)) : 0}
              </span>
            <p>Actual Cost</p>
          </div>
          <div className={`column ${PmModuleStyle.column}`}>
            <img src={profitreport} />
            <span>
              {decisionhistory?.summary?.projectedProfitValue ? checkNum(Number(decisionhistory?.summary?.projectedProfitValue)) : 0}
              </span>
            <p>Actual Profit</p>
          </div>
          <div className={`column ${PmModuleStyle.column}`}>
            <img src={trophy} />
            <span>
              {(decisionhistory && decisionhistory?.summary?.daydelayed != 0) && Math.abs(decisionhistory?.summary?.daydelayed)}
                {
                  decisionhistory ? ((decisionhistory?.summary?.daydelayed === 0) ? " On time" :
                  (decisionhistory?.summary?.daydelayed < 0) ? " days ahead of time " : " days over time") : ""
                }</span>
            <p>Completed in {decisionhistory?.summary?.currentstep} days</p>
          </div>
          <div className={`column ${PmModuleStyle.column}`}>
            <img src={trophy} />
            <span>{decisionhistory?.summary?.status}</span>
            {/* {
              decisionhistory?.summary?.targetAchieved != "1" ? <span>Failure</span> : <span>Success</span>
            } */}
            <p>Target Achieved</p>
          </div>
          <div className={`column ${PmModuleStyle.column}`}>
            <img src={trophy} />
            <span>
              {decisionhistory?.summary?.score ? decisionhistory?.summary?.score : 0}%
              </span>
            <p>Score</p>
          </div>
        </div>

        <div
          className={`${PmModuleStyle["decision-table"]}`}
          style={{ height: decisionPageHeight + "px" }}
        >
          <table
            className={`ui unstackable table ${PmModuleStyle.ui} ${PmModuleStyle.unstackable} ${PmModuleStyle.table}`}
          >
            <thead>
              <tr>
                <th className={`column`}>Decision Date</th>
                <th className={`column`}>Task Plan</th>
                <th className={`column`}>Projected Cost</th>
                <th className={`column`}>Projected Profit</th>
                <th className={`column`}>Project Status</th>
                {/* <th className={`column`}>Ask an expert</th> */}
              </tr>
            </thead>
            <tbody>
              {decisionhistory?.detail?.map((detailObj, index) => (
                <tr key={index + "_03"}>
                  <td>{detailObj?.decisiondate}</td>
                  <td className={`${PmModuleStyle["investment-list"]}`}>
                    <ul className={`${PmModuleStyle["forecasted-list"]}`}>
                      {
                        detailObj?.taskoptions?.map((obj)=>{
                          return <li style={{fontWeight:`${String(obj).indexOf(":") != -1 ? "bold": "normal"}`, margin:"4px", fontSize:`${String(obj).indexOf(":") != -1 ? "14px": "12px"}`}}>{obj}</li>
                        })
                      }
                    </ul>
                  </td>
                  <td>
                    {checkNum(Number(detailObj?.ProjectedCost))}
                  </td>
                  <td>
                  {checkNum(Number(detailObj?.ProjectedProfit))}
                  </td>
                  <td>{detailObj?.projectStatus.replaceAll("_"," ")}</td>
                  {/* <td><img className={detailObj?.expertAdviceTaken ? 'advice_taken' : 'advice_nottaken'} src={detailObj?.expertAdviceTaken ? task_indicator_achieved : task_indicator_notachieved} /></td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </motion.div>
  );
};

export default DecisionHistory;
